module.exports = __webpack_public_path__ + "media/images/twitter-0e121c54c34dc6a02d9266a1cdef6e5b5da5a20bcec14b6866ecab38811c920d.png";